/**
 * functions.js — Supabase Edge Function callable wrappers
 *
 * Frontend wrappers for calling Edge Functions from the app.
 * Auth token is passed automatically via the Supabase client session.
 */

import { supabase } from '../supabase';

async function callEdgeFunction(name, body = {}) {
  const { data: { session } } = await supabase.auth.getSession();
  if (!session) throw new Error('Not authenticated');

  const response = await fetch(
    `${process.env.REACT_APP_SUPABASE_URL}/functions/v1/${name}`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${session.access_token}`,
        'apikey': process.env.REACT_APP_SUPABASE_ANON_KEY,
      },
      body: JSON.stringify(body),
    }
  );

  const data = await response.json();
  if (!response.ok) throw new Error(data.error || `Edge Function error: ${response.status}`);
  return data;
}

/**
 * Save a Teller enrollment from the Connect widget.
 * Stores the access token securely server-side, saves enrollment metadata.
 */
export async function callSaveTellerEnrollment({ enrollmentId, accessToken, institutionName, institutionId }) {
  return callEdgeFunction('save-teller-enrollment', {
    enrollmentId,
    accessToken,
    institutionName,
    institutionId,
  });
}

/**
 * Trigger a manual sync for the current user.
 * Will call the sync-teller Edge Function once it's deployed.
 */
export async function callTriggerSync() {
  return callEdgeFunction('sync-teller');
}

/**
 * Disconnect a Teller enrollment — deletes the stored token and marks inactive.
 */
export async function callDisconnectTellerEnrollment(enrollmentId) {
  return callEdgeFunction('disconnect-teller-enrollment', { enrollmentId });
}

// Legacy stubs — unused after Firebase migration, kept to avoid import errors
export async function callBackfillBillPatterns() { return {}; }
export async function callBackfillBudgetPeriods() { return {}; }
export async function callDeleteUserData() { return {}; }
